import type { Catalog } from '..'

export const auth: Catalog['auth'] = {
  networkError: 'Não foi possível acessar o doop — verifique sua conexão e tente de novo.',
  unreachable: 'Não foi possível acessar o doop — ele pode estar reiniciando. Tente de novo em instantes.',
  somethingWentWrong: 'Algo deu errado',
  somethingWentWrongTitle: 'Algo deu errado.',

  titleSignin: 'Que bom ver você de novo.',
  titleSignup: 'Crie sua conta.',
  titleForgot: 'Redefina sua senha.',
  titleReset: 'Escolha uma nova senha.',

  forgotBlurb: 'Informe o e-mail da sua conta e enviaremos um link para redefinir a senha.',
  resetBlurb: 'Escolha uma nova senha para a sua conta.',
  taglineBefore: 'Um canvas compartilhado para humanos',
  taglineEmphasis: 'e agentes',
  taglineAfter: '.',
  taglineSignin: 'Entre para acessar seus canvases.',
  taglineSignup: 'Crie sua conta para começar a desenhar.',

  signInWith: 'Entrar com {provider}',
  signUpWith: 'Criar conta com {provider}',
  or: 'ou',

  nameLabel: 'Nome',
  emailLabel: 'E-mail',
  emailPlaceholder: 'voce@exemplo.com',
  passwordLabel: 'Senha',
  newPasswordLabel: 'Nova senha',
  passwordPlaceholder: 'Pelo menos 8 caracteres',
  forgotPassword: 'Esqueceu a senha?',

  signIn: 'Entrar',
  signUp: 'Criar conta',
  sendResetLink: 'Enviar link de redefinição',
  setNewPassword: 'Definir nova senha',
  noAccountSignUp: 'Ainda não tem conta? Criar conta',
  haveAccountSignIn: 'Já tem uma conta? Entrar',
  createAccountInstead: 'Criar uma conta',
  signInInstead: 'Entrar com esta conta',
  resendVerification: 'Reenviar e-mail de verificação',

  ssoAccountNotLinked:
    'Esse e-mail já tem uma conta no doop que não pôde ser vinculada automaticamente — entre com e-mail e senha.',
  ssoEmailMismatch: 'O e-mail com que você entrou não corresponde à conta de onde você começou — tente de novo.',
  ssoEmailMissing:
    'Seu provedor de identidade não compartilhou um endereço de e-mail — o doop precisa de um para você entrar.',
  ssoDesktopHandoff: 'Esse link de acesso expirou — comece de novo e conclua no navegador em poucos minutos.',
  ssoFailed: 'Não foi possível entrar — tente de novo ou use e-mail e senha.',
  startFailed: 'Não foi possível iniciar o acesso — tente de novo ou use e-mail e senha.',
  browserSignInNotice: 'Conclua o acesso no navegador — o doop conecta você aqui assim que você voltar.',
  verificationSent: 'E-mail de verificação enviado — confira sua caixa de entrada.',
  resetLinkSent: 'Se existir uma conta com esse e-mail, um link de redefinição já está a caminho.',
  resetLinkInvalid: 'Este link de redefinição é inválido ou expirou — solicite um novo.',
  passwordUpdated: 'Senha atualizada — entre com a sua nova senha.',
  emailNotVerified: 'Este e-mail ainda não foi verificado.',
  noAccountFound: 'Nenhuma conta encontrada com este e-mail.',
  accountExists: 'Já existe uma conta com este e-mail.',
  verifyEmailSent: 'Quase lá — enviamos um link de verificação para {email}. Abra-o para ativar sua conta.',

  consentTitle: 'Conectar {name}?',
  consentTitleGeneric: 'Conecte seu agente',
  consentSignedInAs: 'Sessão iniciada como {email}',
  consentScope:
    'Este agente poderá ler seu perfil e ler, criar, editar e excluir designs nos canvases que você pode acessar. As alterações dele serão atribuídas à sua conta.',
  consentExpired: 'Esta solicitação de conexão expirou. Comece de novo pelo seu agente.',
  consentLoadFailed: 'Não foi possível carregar a conexão.',
  consentFinishFailedRetry: 'Não foi possível concluir a conexão. Comece de novo pelo seu agente.',
  consentFinishFailed: 'Não foi possível concluir a conexão.',
  connecting: 'Conectando…',
  connect: 'Conectar',

  desktopLinkIncomplete: 'Este link de acesso está incompleto — volte ao app do doop e tente de novo.',
  desktopStartFailed: 'Não foi possível iniciar o acesso — volte ao app do doop e tente de novo.',
  desktopSigningIn: 'Entrando…',
  desktopToProvider: 'Levando você ao seu provedor de identidade para o app do doop.',
  desktopSignedIn: 'Você entrou.',
  desktopHandoffFailed: 'Não foi possível passar o acesso para o app do doop. Volte ao app e tente de novo.',
  desktopSendingBack: 'Levando você de volta ao app do doop… Você pode fechar esta aba depois.',
  openDoop: 'Abrir o doop',
  desktopConnectTitle: 'De volta ao app do doop.',
  desktopConnectBody: 'O doop conclui a conexão no app, para a conta conectada lá. Você pode fechar esta aba depois.',
  desktopConnectFailed: 'Não foi possível passar a conexão para o app do doop. Volte ao app e tente de novo.',

  viewingAsBefore: 'Visualizando como',
  viewingAsAfter: '— somente leitura, expira em 15 minutos.',
  stopViewing: 'Parar de visualizar',
  leaving: 'Saindo…',
}
